
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class AdultEnglishPlan extends Vue {
    navigateToAdultPlan() {
        this.$router.push('/plan/otona')
    }
}
